import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Mail, Phone } from "lucide-react";
import { getThankYouCopy } from "@/i18n";
import EscudoNacional from "@/components/EscudoNacional";

export default function ThankYouPage() {
  const copy = getThankYouCopy();
  const navigate = useNavigate();

  return (
    <div className="kv-thankyou" data-testid="thankyou-page">
      <div className="kv-thankyou-card">
        <div className="kv-thankyou-icon">
          <CheckCircle2 size={38} />
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.6rem", marginBottom: "1rem" }}>
          <EscudoNacional size={30} />
          <span style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.2rem", color: "var(--kv-navy)", fontWeight: 700 }}>
            Killavox
          </span>
        </div>
        <div style={{ fontSize: "0.78rem", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--kv-emerald)", fontWeight: 700, marginBottom: "0.5rem" }}>
          {copy.eyebrow}
        </div>
        <h1 className="kv-h1" style={{ fontSize: "2rem" }}>{copy.title}</h1>
        <p className="kv-body" style={{ marginTop: "0.9rem", fontSize: "1rem" }}>
          {copy.subtitle}
        </p>
        <div style={{ marginTop: "1.5rem", padding: "1rem 1.25rem", background: "var(--kv-gray)", borderRadius: 14, textAlign: "left" }}>
          <p style={{ fontSize: "0.92rem", color: "var(--kv-navy)", marginBottom: "0.5rem" }}>
            {copy.line1}
          </p>
          <p style={{ fontSize: "0.9rem", color: "var(--kv-muted)" }}>{copy.line2}</p>
        </div>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="kv-btn-primary"
          style={{ marginTop: "1.75rem", justifyContent: "center" }}
          data-testid="thankyou-back-home"
        >
          <ArrowLeft size={16} /> {copy.backHome}
        </button>
        <div style={{ marginTop: "1.75rem", padding: "1rem 0 0", borderTop: "1px solid var(--kv-gray-2)", fontSize: "0.85rem", color: "var(--kv-muted)" }}>
          <div style={{ fontWeight: 700, color: "var(--kv-navy)", marginBottom: "0.35rem" }}>{copy.supportLabel}</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "center" }}>
            <a href={`mailto:${copy.supportEmail}`} className="kv-link" style={{ display: "inline-flex", alignItems: "center", gap: "0.35rem" }}>
              <Mail size={14} /> {copy.supportEmail}
            </a>
            <a href={`tel:+5117304820`} className="kv-link" style={{ display: "inline-flex", alignItems: "center", gap: "0.35rem" }}>
              <Phone size={14} /> {copy.supportPhone}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
